
<article>

  <div class="row row-product-table vertical-align row-bottom-bordered">

    <!-- Thumb -->
    <div class="image-wrapper link top-padding bottom-padding" (click)="openDetails()">
      <div class="image" [appFlyToCart]="product?._id" cartSelector="cartbutton"
        [ngStyle]="{'background-image': 'url(' + thumbUrl + '), url(\'/assets/images/no-image-placeholder.png\')'}">
      </div>
    </div>

    <!-- Product name -->
    <div class="col col-xxl-4 col-xl-5 col-lg-5 col-md-6 col-product link text text-product top-padding bottom-padding" (click)="openDetails()">
      <strong>{{ product.name }} <span *ngIf="getFacetValues('collectionyear')">({{ getFacetValues('collectionyear') }})</span></strong><br/>
      <div class="d-xxl-none">
        <span class="color">{{ 'details.color' | translate }}: {{ product.facets | facetValues:'color':combinedFacets }}</span><br/>
        <span class="size">{{ 'details.size' | translate }}: {{ product.facets | facetValues:'size':combinedFacets }} </span>
      </div>
      <span class="productcode">{{ product.code }}</span>
      <!-- backorder info -->
      <p class="backorder" *ngIf="isProductInBackorder">
        {{ 'product.backorder-info' | translate:{ totalInBackOrder: product?.backorderInfo.totalInBackorder | numberFormat, week: product?.backorderInfo.firstDeliveryDate | momentDateFormat: 'w' } }}
      </p>
    </div>

    <!-- Color -->
    <div class="col col-xxl-2 col-xl-2 col-color d-none d-xxl-block text top-padding bottom-padding">{{ product.facets | facetValues:'color':combinedFacets }}</div>

    <!-- Size -->
    <div class="col col-xxl-1 col-xl-1 col-size d-none d-xxl-block text top-padding bottom-padding">{{ product.facets | facetValues:'size':combinedFacets }}</div>

    <!-- Price -->
    <div class="col col-xxl-1 col-xl-2 col-lg-2 col-price d-none d-lg-block text text-right top-padding bottom-padding">
      {{ price | price:currency }}
    </div>

    <!-- Stock -->
    <app-stock-info class="col col-xxl-2 col-xl-2 col-lg-2 col-stock col-stock d-none d-lg-block text top-padding bottom-padding"
      [product]="product"
      [layout]="'table'">
    </app-stock-info>

    <!-- Quantity picker -->
    <div class="col col-xxl-2 col-xl-3 col-lg-3 col-md-6 col-action top-padding bottom-padding no-padding-left">

      <app-quantity-picker
        *ngIf="canBuy"
        class="product-table-mode"
        [itemId]="product?._id"
        [value]="actualQuantity"
        [minQuantity]="minQuantity"
        [viewType]="'table'"
        [quantityType]="quantityPicker"
        [stepping]="stepping"
        (quantityChanged)="addCart($event)">
      </app-quantity-picker>

      <div *ngIf="inCart" class="is-in-cart">
        <i class="fa fa-check"></i>
      </div>

    </div>

    <!-- Stock
    <div class="col-2 text text-right top-padding bottom-padding ">{{ firstAvailableStock }}</div>
    -->


  </div>

</article>
